import React, { useCallback, useContext } from "react";

import { AuthContext } from "components/AuthProvider/AuthProvider";
import { Params as SubmitEditableTableChangesParams } from "api/makeApiRequestType/makeSubmitEditableTableChanges";
import { Auth } from "api/makeApiRequest";
import { ApiRequest } from "api/makeApiRequest/ApiRequest";

type Params<T> = {
	setWaitModalTitle: React.Dispatch<React.SetStateAction<string>>;
	setWaitModalIsShowing: React.Dispatch<React.SetStateAction<boolean>>;
	saveData: (
		args: SubmitEditableTableChangesParams<T>,
		auth: Auth
	) => ApiRequest<{}>;
	onSaved: () => void;
};

export function useOnEditTable<T>({
	setWaitModalTitle,
	setWaitModalIsShowing,
	saveData,
	onSaved
}: Params<T>) {
	const [{ uid }] = useContext(AuthContext);

	const onEditTable = useCallback(
		(rows: { old?: T; new?: T }[]) => {
			const title = rows.every(row => !row.new) ? "Deleting" : "Saving";

			setWaitModalTitle(title);
			setWaitModalIsShowing(true);

			if (!uid) {
				throw new Error("No Uid");
			}

			const req = saveData(
				{
					uid,
					rows
				},
				{ uid }
			);

			const ready = req.ready.then(response => {
				onSaved();
				setWaitModalIsShowing(false);
			});

			return {
				ready,
				abort: () => req.abort(),
				aborted: () => req.aborted()
			};
		},
		[uid, setWaitModalTitle, setWaitModalIsShowing, onSaved, saveData]
	);

	return onEditTable;
}
